module.exports = __webpack_public_path__ + "d812f234a79fbf36d35815ba98a803bd.webp";